module.exports = __webpack_public_path__ + "static/img/07.b5cafe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/07.jpg
// module id = jGYZ
// module chunks = 0